module.exports = __webpack_public_path__ + "img/banner-t.0e7d270f.png";